export default __webpack_public_path__ + "static/3-9bb8a404e5641db2083169e49d11717d.jpg";